import React, { useEffect, useMemo, useState } from "react";
import {FromHead} from "ellow-web-ui-components-library";
import Styles from "./styles.module.scss";
import { useForm } from 'react-hook-form';
import { FormInput } from '../../../wrappers/formInput';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import * as CONSTANTS from '../../../utils/CONSTANTS';
import TagLabel from '../../../compopnents/TagLabel';
import Combodropdown from '../../../compopnents/autoComplete'
import {skills} from "../../../utils/Skill";
import { Error } from "@progress/kendo-react-labels";
import { PhoneInput } from "../../../wrappers/phoneInput";
import "yup-phone";
import Button from "../../../compopnents/button";
import { DropDownInput } from "../../../wrappers/selectInput";

export type CompanyDetailsFormFields = {
  workEmail: string;
  phoneNumber: string;
  companyName: string;
  firstName: string;
  designation: string;
}

interface Props {

  ClickHandler: any
  Back: any
  newBlur: any
  defaultValues: {
    companyName: string;
    designation: string;
    workEmail: string;
    phoneNumber: string;
    skills:{id: number, name: string}[]
  },
  customerId: any
  status: any
  disable: boolean
  userId: string
}

const validationSchema = Yup.object({
 
  workEmail: Yup.string()
    .required("Field is required")
    .email('Please provide a valid Work Email'),
  phoneNumber: Yup.string()
  .required('Field is required')
  .min(5,'Provide a valid Phone number')
  .max(15,'Provide a valid Phone number'),
  companyName: Yup.string()
  .required("Field is required"),
  firstName: Yup.string()
  .required("Field is required") 
  // website: Yup.string()
  //   .required("Field is required")
  //   .matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/,'Please Provide a valid company address'),
  // country: Yup.string()
  //   .required("Field is required"),
  // city: Yup.string()
  //   .required("Field is required"),
  // size: Yup.string()
  //   .required("Field is required")
})

const CompanyDetails: React.FC<Props> = ({
  ClickHandler,
  Back,
  defaultValues,
  newBlur,
  customerId,
  status,
  disable,
  userId
}) => {

  const formOptions = { resolver: yupResolver(validationSchema),defaultValues:useMemo(() => {
    return defaultValues;
  }, [defaultValues]) };

  const {
    register,
    handleSubmit,
    control,
    setValue,
    reset,
    formState: { errors },
  } = useForm<CompanyDetailsFormFields>(formOptions);

  const [error, setError] = useState('')


  let query: any = window.location.href;
  let urlParams: any = new URL(query);
  let passedEmail: any = urlParams.search.slice(7)
  let email1: any = passedEmail.replace('%40', '@')
   
  useEffect(() => {  

    if(status === 1){
      setValue('firstName','')
      setValue('phoneNumber','')
      setValue('designation','')
      setValue('companyName','')
      setAddedSkills([])
      if(email1 !== ''){
        setValue('workEmail',email1) 
      }
    }
    if(status === '2'){   
      if(defaultValues){
        const techStack = defaultValues.skills ? defaultValues.skills.map((item) => {    
          return ({
            name: item.name, id: item.id, 
            other: CONSTANTS.Skills.filter(skill => skill.id === item.id).length === 0
          })
        }) : []
        setAddedSkills(techStack)
      }
      if( defaultValues && defaultValues.workEmail){
        reset(defaultValues);  
      } else{
        setValue('workEmail',email1) 
      }
    }
    
    if(status === '3'){
      const techStack = defaultValues.skills ? defaultValues.skills.map((item) => {    
        return ({
          name: item.name, id: item.id, 
          other: CONSTANTS.Skills.filter(skill => skill.id === item.id).length === 0
        })
      }) : []
      setAddedSkills(techStack)
      setValue('companyName',defaultValues.companyName)
      setValue('designation',defaultValues.designation)
      setValue('firstName','')
      setValue('phoneNumber', '91')
      if(email1 !== ''){
        setValue('workEmail', email1)
      }
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues, status]);
    
  const onSubmitForm = (data: any) => { 
    
    localStorage.setItem('email', data.workEmail)
    localStorage.setItem('name', data.firstName)
    
    let skills = addedSkills.filter((item) => item.name !== 'Others').filter((item) => item.id !== 0)
    let hasError: boolean = false
    if ( skills.length === 0){
      setError('Minimum one skill required')
      hasError = true
    }
    if ( skills.length > 3){
      hasError = true
      setError('Maximum three skills allowed')
    }
    data.skills = skills.map((item) => {
      return ({
          "id": item.id,
          "name": item.name
      })
    })
    
    if (!hasError){

      if(userId !== ''){
        const newValue: any = {
          customerMetadata: data,
          customerId: customerId,
          submittedBy: 'CUSTOMER',
          companyType: 1,
          customerStatus: 1,
          userId: userId
        } 
        ClickHandler(newValue)
      }else{
        const newValue: any = {
          customerMetadata: data,
          customerId: customerId,
          submittedBy: 'CUSTOMER',
          companyType: 1,
          customerStatus: 1
        } 
        ClickHandler(newValue)
      }   
    }
  }

  const onBlur = (e: any) => {
    newBlur(e.target.value)
  }

  const [addedSkills, setAddedSkills] = useState<{ name: string, id: number, other: boolean }[]>([])
  const [skillOthers, setSkillOthers] = useState<boolean>(false)

  const getAddedSkills = () => [...CONSTANTS.Skills, ...addedSkills.filter(item => item.other)]
  const getDefaultSkills = (item: { name: string, id: number }) => addedSkills ? !!addedSkills.filter(id => id.id === item.id).length : false

  const skillChange = (e: any, skill: { name: string, id: number }) => {
      

    setError('')
    let updatedSkill: { name: string, id: number, other: boolean }
      = { ...skill, other: e === 'addValue' }

    if (skill !== null) {
      if (e.value || e === 'addValue') {
        addedSkills.push(updatedSkill)
        // setErros({ ...errors })
        if (skill.name === "Others") {
          setSkillOthers(true)
        }
      }
      else {
        const index = addedSkills.findIndex(item => item.id === skill.id);
        if (index > -1) {
          addedSkills.splice(index, 1);
        }
        if (skill.name === "Others") {
          setSkillOthers(false)
        }
      }
    }
    setAddedSkills([...addedSkills])
  }

  

  return (
    <form >
      <div className={Styles.comnpanyForm}>

      {/* <FromHead>May I know the details about you and your company?</FromHead> */}

      <div className="half-form-wrap">
      {/* <div className="form-group">
      <FormInput<CompanyDetailsFormFields>
            id="Name"
            type="text"
            name="contactName"
            label="Name*"
            placeholder="Name"
            onchange={(e:any) => e.target.value = ("" + e.target.value.charAt(0)).toUpperCase()+e.target.value.slice(1)}
            register={register}
            errors={errors}
          />
        </div> */}
        {/* <div className="form-group">
        <FormInput<CompanyDetailsFormFields>
            id="companyName"
            type="text"
            name="companyName"
            label="Company Name*"
            placeholder="Company Name"
            register={register}
            errors={errors}
          />
        </div> */}
        </div>
        {/* <div className="half-form-wrap">
        <div className="form-group">
        <FormInput<CompanyDetailsFormFields>
            id="companyWebsite"
            type="text"
            name="website"
            label="Company Website*"
            placeholder="Company Website"
            register={register}
            errors={errors}
          />
         </div>
           <DropDownInput<CompanyDetailsFormFields>
            data= {CONSTANTS.companySize}
            name = 'size'
            onChange={(e: any) => handleChange(e, 'size')}
            value={defaultValues.size}
            register={register}
            label='What is your company size?'
            errors={errors}
            // textField="text"
            // dataItemKey="id"
            control = {control}
            />
         </div> */}
      
      <FromHead>What are your contact details?</FromHead>
      <div className="half-form-wrap">

         <div className="form-group">
          <FormInput<CompanyDetailsFormFields>
            id="workEmail"
            type="text"
            name="workEmail"
            label="Work Mail*"
            placeholder="Work Email"
            // defaultValue={email}
            register={register}
            errors={errors}
            onBlur={onBlur}
          />
          </div>
          <div className="form-group">
          <PhoneInput<CompanyDetailsFormFields>
            name="phoneNumber"
            label="Phone Number*"
            register={register}
            errors={errors}
            control={control}
            inputProps={register}
            />
          </div>
    </div>
    <div className="half-form-wrap">
      <div className="form-group">
        <FormInput<CompanyDetailsFormFields>
          id="companyName"
          type="text"
          name="companyName"
          label="Company Name*"
          placeholder="Company Name*"
          onchange={(e:any) => e.target.value = ("" + e.target.value.charAt(0)).toUpperCase()+e.target.value.slice(1)}
          register={register}
          errors={errors}
        />
      </div>
      <div className="form-group">
        <FormInput<CompanyDetailsFormFields>
          id="Name"
          type="text"
          name="firstName"
          label="Name*"
          placeholder="Name"
          onchange={(e:any) => e.target.value = ("" + e.target.value.charAt(0)).toUpperCase()+e.target.value.slice(1)}
          register={register}
          errors={errors}
        />
      </div>
        </div>
        <div className="half-form-wrap">
        <div className="form-group">
          <DropDownInput<CompanyDetailsFormFields>
            name="designation"
            label="Designation"
            control={control}
            errors={errors}
            register={register}
            data={['Recruiter','C-Level','Manager']}
          />
        </div>
      </div>

        <FromHead>Which skills are you looking for?*</FromHead>
            <div className={Styles.tagLabelWrap}>
              {getAddedSkills().map((skill, key) => <TagLabel label={skill.name}
                key={key}
                value={skill.id}
                checked={getDefaultSkills(skill)}
                handleChange={(e: any) => skillChange(e, skill)} />)}

              {skillOthers && <div className={Styles.tagDropdown}>
                <Combodropdown
                  placeholder="Please search your skill"
                  data={skills}
                  name='name'
                  id='id'
                  handleChange={(value: { name: string, id: number }) => skillChange("addValue", value)}
                />
              </div>}
              <Error>{error}</Error>
            </div>
            <div className={Styles.privacyPolicy}>By submitting this form, I agree with Ellow's <a href="https://www.ellow.io/privacy-policy/">Privacy Policy && <a href="https://www.ellow.io/terms-of-service/">Terms and Conditions</a></a>. I understand I can unsubscribe at any time.</div> 
      </div>
      <div className={Styles.formAction}>
        <div></div>
        <Button variant="primary" onClick={handleSubmit(onSubmitForm)} disabled={disable}>Now, Add Company Details</Button>
      </div>
   
    </form>
  );

}

export default CompanyDetails;